import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {KeyLogService} from '../../services/key-log.service';
import {flatMap, switchMap, takeUntil, tap} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';

@Component({
    templateUrl: 'key-log.component.html',
})
export class KeyLogComponent implements OnInit, OnDestroy {
    $destroy = new Subject();

    constructor(public keyLogService: KeyLogService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.keyLogService.getBuildings()
            .pipe(
                takeUntil(this.$destroy)
            )
            .subscribe();

        this.urlService
            .onUrlChange
            .pipe(
                tap(() => {
                    this.keyLogService.tabId = this.urlService.queryParams['tab'];
                    this.keyLogService.showDetailedView = false;
                    this.keyLogService.selectedItemData = null;
                }),
                switchMap(
                    () => this.keyLogService.getDataByQueryParams(true)
                ),
                takeUntil(this.$destroy)
            )
            .subscribe();
        this.urlService.setQueryParams('allKeyLogs');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.keyLogService.resetData();
        this.urlService.resetQueryParams();
        this.$destroy.next();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.keyLogService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/key-log/key-log.component.ts